module.exports = __webpack_public_path__ + "img/b3eed173482d4c3b263e18ccb4a76ee1.8172a98c.jpg";